export default "__VITE_ASSET__CCoEuhBn__"